import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import {Provider ,useSelector} from "react-redux";
import store from "./redux/store";
import ContantComponent from './Components/ContantCom.js';
import { CookiesProvider } from "react-cookie";
import './index.scss';
import './index.css';
import 'bulma/css/bulma.min.css';
import 'bulma-calendar/dist/css/bulma-calendar.min.css';

const getFitZoom = () =>
{
    // Relative to this display's width so a maximized window lands near 100%.
    const refW = window.screen.availWidth || 1920;
    return Math.max(1, Math.min(100, (window.innerWidth / refW) * 100));
}

const applyChromeZoom = (zoomPct) =>
{
    const z = zoomPct / 100;
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");

    // Root zoom ≈ Chrome Ctrl+/- : layout grows, then zooms so content still fills.
    html.style.zoom = zoomPct + "%";
    html.style.width = (window.innerWidth / z) + "px";
    html.style.height = ((window.innerHeight / z)) + "px";
    html.style.overflow = "hidden";

    body.style.width = "100%";
    body.style.height = "100%";
    body.style.margin = "0";
    body.style.overflow = "hidden";

    if(root)
    {
        root.style.width = "100%";
        root.style.height = "100%";
        root.style.overflow = "hidden";
    }
}

const clearChromeZoom = () =>
{
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");

    html.style.zoom = "";
    html.style.width = "";
    html.style.height = "";
    html.style.overflow = "";
    body.style.width = "";
    body.style.height = "";
    body.style.margin = "";
    body.style.overflow = "";
    if(root)
    {
        root.style.width = "";
        root.style.height = "";
        root.style.overflow = "";
    }
}

const MainPage = () =>
{
    const { frame } = useSelector((state) => state.frame);

    useEffect(() =>
    {
        const updateZoom = () => applyChromeZoom(getFitZoom());
        updateZoom();
        window.addEventListener("resize", updateZoom);
        return () =>
        {
            window.removeEventListener("resize", updateZoom);
            clearChromeZoom();
        };
    },[])

    return  (
    <>
      {(frame === "Contant" ? <ContantComponent />: <></>)}
      <p className={frame !== "Contant"  ? 'subtitle is-5 has-text-white' : "subtitle is-5 has-text-black"} style={{"position" : "absolute","bottom" : "10px" ,"right" : "20px","zIndex" : 9999}}>© {new Date().getFullYear()} Bitsonic.ai</p>
    </>
   );
}

ReactDOM.render(
    <Provider store={store}>
        <CookiesProvider>
          <MainPage />
        </CookiesProvider>
    </Provider>,
  document.getElementById('root')
);
